import React from 'react';

class NotFound extends React.Component {
  render() {
    return (
      <div className="login-container">
        <div className="text-center login-block four-zero-four">
          <p className="line1">ページが見つかりません</p>
          <p className="not-found">404 not found</p>
          <p className="line2">申し訳ございません。お探しのページまたはファイルは見つかりませんでした。<br />
            下記の「トップページに戻る」ボタンよりトップページにお戻りください。</p>
          <a href="/" className="btn mfc-btn-blue medium">トップページに戻る</a>
        </div>
      </div>
    );
  }
}

export default NotFound;
